export const MAX_SELECTION_COUNT = 1000;

export const onBeforeUnloadOn = () => {
    window.onbeforeunload = function () {
        return true;
    };
};

export const onBeforeUnloadOff = () => {
    window.onbeforeunload = null;
};

export const isNumber = (v) => typeof v === 'number';

export const isEmpty = (v) => {
    return Array.isArray(v) ? v.length === 0 : [undefined, null, ''].includes(v)
}
export const objToQueryString = (obj) => {
    const keyValuePairs = [];
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            keyValuePairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
        }
    }
    return keyValuePairs.join('&');
}
export const queryStringToObject = (queryString) => {
    const obj = {};
    if (queryString) {
        const pairs = queryString.substring(1).split("&");
        pairs.forEach(pair => {
            const [key, value] = pair.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        });
    }
    return obj;
}
export const removeQueryStringFromUrl = () => {
    const newUrl = window.location.href.split('?')[0];
    window.history.replaceState(null, null, newUrl);
}
export const checkMatch = (arr1, arr2) => {
    for (let i = 0; i < arr1.length; i++) {
        if (arr2.includes(arr1[i])) {
            return true;
        }
    }
    return false;
}
export function removeNullProperties(obj) {
    for (let prop in obj) {
        if (obj[prop] === null) {
            delete obj[prop];
        }
    }
    return obj;
}

export const containsAnyLetter = (str) => {
    for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i);
        if ((code > 64 && code < 91) ||
            (code > 96 && code < 123) ||
            (code > 1039 && code < 1104)){
            return true;
        }
    }
    return false;
}



// WEBPACK FOOTER //
// ./App/services/utils.js